import { httpClient } from './http-client';
const knowledgeBaseBackendPrefix = '/api/knowledge-base';

export default {
	getNews(params) {
		return httpClient.get(knowledgeBaseBackendPrefix, { params });
	},
	getTags() {
		return httpClient.get(knowledgeBaseBackendPrefix + '/tags');
	}
};
